export interface Award {
  image: string;
  title: string;
  description?: string;
}

export interface DownloadConfig {
  pdfUrl: string;
  downloadFileName: string;
  eventName: string;
}

export interface Product {
  id: number;
  slug: string;
  title: string;
  description: string;
  image: string;
  detailImage?: string;
  category: string;
  detailedDescription?: string;
  award?: Award;
  downloadConfig?: DownloadConfig;
}

export const products: Product[] = [
  {
    id: 1,
    slug: 'konnect-better-unlocking-the-power-of-your-relationships',
    title: 'konnect better: unlocking the power of your relationships',
    description: 'Discover practical insights and real tools to understand yourself and strengthen your connections.',
    image: '/images/konnect_better_book(2).png',
    detailImage: '/images/konnect-better-book-styled.png',
    category: 'books',
    detailedDescription:
      "Volume 1. In a world drowning in noise, relentless distractions, and shallow connections, it's all too easy to lose sight of what truly matters: real, meaningful relationships. konnect better is your road map to reclaiming and enriching the connections that make life worth living.\n\nPacked with insights from modern psychology, proven strategies, and hands-on exercises, this guide is designed for anyone ready to invest in deeper, more fulfilling relationships. You'll discover practical tools to transform how you connect with the people who matter most.\n\nThis is the first in a groundbreaking three-part series, where each chapter dives into the essential pillars of connection—from building trust and fostering self-awareness to mastering emotional fluency. Whether it's strengthening your bonds with loved ones, colleagues, or even yourself, this book offers a clear, actionable path to cultivating relationships that truly last.\n\nIf you're ready to elevate your relationships and transform the quality of your life, let konnect better be your trusted companion. Because in the end, our most valuable asset isn't what we have, but who we have.",
    award: {
      image: '/pinnacle-award.png',
      title: 'Pinnacle Book Achievement Award',
      description: 'Winner of the Pinnacle Book Achievement Award'
    }
  },
  {
    id: 2,
    slug: 'the-connection-blueprint',
    title: 'the connection blueprint',
    description: 'Interactive exercises to help you explore your values, strengths, and growth areas.',
    image: '/images/the_connection_blueprint.png',
    category: 'playbooks',
    detailedDescription:
      'Step into clarity. This playbook is designed to spark powerful self-discovery and stronger relationships with a little practice. We believe that before we can deepen our connections with others, we need to first understand ourselves. Through self-guided exercises and research-backed insights, you can illuminate your core values and natural strengths. By helping you recognize your patterns, it sets the stage for a more intentional way of relating to yourself and others',
    downloadConfig: {
      pdfUrl: 'https://strapistore.blob.core.windows.net/uploads/uploads/The_connection_blueprint_e537c853b2.pdf',
      downloadFileName: 'The_Connection_Blueprint.pdf',
      eventName: 'connection-blueprint'
    }
  },
  {
    id: 5,
    slug: 'relationship-assessment-scale',
    title: 'relationship assessment scale',
    description: 'Understand the current state of your relationships and how it correlates to other measures of love, trust, and commitment.',
    image: '/images/relationship_scale.png',
    category: 'exercises',
    detailedDescription:
      'Understand the true state of your relationships with a tool grounded in the research of Susan Hendrick, designed to measure overall relationship satisfaction across a wide range of relationship types. This exercise can provide a clear snapshot of where you stand with trust, emotional intimacy, and connections today. Equipped with these insights, you’ll be able to celebrate what’s working well and identify meaningful opportunities to deepen closeness.',
    downloadConfig: {
      pdfUrl: 'https://strapistore.blob.core.windows.net/uploads/uploads/relationship_assessment_scale.pdf',
      downloadFileName: 'Relationship_Assessment_Scale.pdf',
      eventName: 'relationship-assessment-scale'
    }
  },
  {
    id: 6,
    slug: 'communication-style-quiz',
    title: 'communication style quiz',
    description: 'A research-based tool to uncover your natural ways of expressing and listening.',
    image: '/images/communication_quiz.png',
    category: 'exercises',
    detailedDescription:
      "Grounded in communication theory and interpersonal psychology, this quiz helps you identify your communication styles and the patterns that come with them. You'll see how your style influences the way you express yourself, listen to others, and handle conversations. With these insights, you can lean into your strengths and adopt new strategies to communicate with more confidence, clarity, and empathy."
  },
  {
    id: 9,
    slug: 'the-konnection-game',
    title: 'the konnection game',
    description: 'Simple interactive prompts that encourage reflection, awareness and inner balance in your daily life.',
    image: '/images/card_game_konnect_better.png',
    category: 'games',
    detailedDescription:
      'Designed for groups, this edition turns meaningful connections into a shared experience. With prompts that spark honest conversations and reflections, it can help friends, families, or teams explore new sides of each other. Perfect for dinner tables, retreats, or gathering, it creates an atmosphere where everyone feels seen, values, and closer one card at a time.'
  }
];

export const getProductBySlug = (slug: string) => products.find((product) => product.slug === slug);
